var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
import React, { useCallback, useEffect, useMemo } from 'react';
import { LayoutConst } from './layout.module';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useAdvancedLockBodyScroll, useIsMobile } from '@brg/ui';
import { CloseModalIcon } from './CloseIconNew';
import CardSelectModal from '../../components/modals/CardSelectModal';
import SendProjectModal from "../../components/modals/SendProjectModal";
import { PreviewerModal } from "../../components/modals/previewerModal/previewerModal";
import ProductsSelectModal from '../../components/modals/ProductsSelectModal';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE, MEDIA_QUERY_NEW_MOBILE } from "../../constants/media";
import CardSelectManyModal from "../../components/modals/CardSelectModal/CardSelectManyModal";
import CodeEditorModal from '../../components/modals/CodeEditorModal.tsx';
import { RetractProjectModal } from '../../components/modals/RetractProjectModal';
import { TemplateModal } from '../../components/modals/TemplateModal/TemplateModal';
import { ReportForm } from '../../components/modals/ReportModal/ReportModal';
export var modalControllerSlice = createSlice({
    name: 'modalController',
    initialState: {
        name: '',
        args: {}
    },
    reducers: {
        showModal: function (state, action) {
            var _a;
            state.args = (_a = action.payload.args) !== null && _a !== void 0 ? _a : {};
            state.name = action.payload.name;
        },
        hideModal: function (state) {
            state.name = '';
            state.args = {};
        },
        updateArgs: function (state, action) {
            var _a;
            state.args = (_a = action.payload.args) !== null && _a !== void 0 ? _a : {};
        }
    }
});
export var modalControllerActions = modalControllerSlice.actions;
export var modalControllerReduces = modalControllerSlice.reducer;
export var SHARED_MODALS = {
    cardSelect: {
        component: CardSelectModal,
    },
    cardSelectMany: {
        component: CardSelectManyModal,
    },
    productsSelect: {
        component: ProductsSelectModal,
    },
    codeEditor: {
        component: CodeEditorModal,
    },
    projectSend: {
        component: SendProjectModal,
    },
    templateModal: {
        component: TemplateModal,
        closable: false,
    },
    report: {
        component: ReportForm,
        solidBackground: true,
        bgColor: '#fff'
    },
    retractProject: {
        closable: false,
        solidBackground: true,
        component: RetractProjectModal,
    },
    previewer: {
        component: PreviewerModal,
        isPreviewer: true,
        solidBackground: true
    }
};
// Селектор для контроллера модалок
export var modalControllerSelector = function (store) { return store.modalController; };
/**
 * Хук для модалок
 */
export var useModal = function () {
    var dispatch = useDispatch();
    var show = useCallback(function (name, props) {
        if (props === void 0) { props = {}; }
        dispatch(modalControllerActions.showModal({ name: name, args: props !== null && props !== void 0 ? props : {} }));
    }, [dispatch]);
    var hide = useCallback(function () {
        dispatch(modalControllerActions.hideModal({}));
    }, [dispatch]);
    var register = useCallback(function (name, modal) {
        SHARED_MODALS[name] = modal;
    }, []);
    var update = useCallback(function (props) {
        dispatch(modalControllerActions.updateArgs(props));
    }, [dispatch]);
    return { show: show, hide: hide, register: register, update: update /* isOpen */ };
};
export var withModal = function (Component) {
    return function WrappedComponent(props) {
        var modal = useModal();
        return React.createElement(Component, __assign({}, props, { modal: modal }));
    };
};
export var ModalControllerContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n  overflow-y: hidden;\n\n  @media (max-width: ", "px) {\n  }\n\n  @media (max-width: ", "px) {\n    overflow-y: overlay;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n  overflow-y: hidden;\n\n  @media (max-width: ", "px) {\n  }\n\n  @media (max-width: ", "px) {\n    overflow-y: overlay;\n  }\n"])), LayoutConst.screen.l, LayoutConst.screen.sm);
export var ModalControllerContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  max-width: 100vw;\n  max-height: 100vh;\n\n  z-index: 200000;\n  background: ", ";\n  background: ", ";\n  background: ", ";\n  backdrop-filter: ", ";\n  user-select: none;\n\n  @media (max-width: ", "px) {\n    margin-top: ", ";\n  }\n\n  @media (max-width: ", "px) {\n    *::-webkit-scrollbar {\n      width: 6px; /* \u0448\u0438\u0440\u0438\u043D\u0430 scrollbar */\n      height: 61px;\n    }\n    *::-webkit-scrollbar-track {\n      background: transparent; /* \u0446\u0432\u0435\u0442 \u0434\u043E\u0440\u043E\u0436\u043A\u0438 */zz\n    }\n    *::-webkit-scrollbar-thumb {\n      border-radius: 3px; /* \u0437\u0430\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0448\u043A\u0438 */\n      background: #d9d9d9;\n      border: 1.55px solid rgba(0, 0, 0, 0); /* \u0438\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043C\u0430\u0440\u0434\u0436\u0438\u043D\u0430 */\n      background-clip: padding-box; /* \u0438\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043C\u0430\u0440\u0434\u0436\u0438\u043D\u0430 */\n    }\n  }\n"], ["\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  max-width: 100vw;\n  max-height: 100vh;\n\n  z-index: 200000;\n  background: ", ";\n  background: ", ";\n  background: ", ";\n  backdrop-filter: ", ";\n  user-select: none;\n\n  @media (max-width: ", "px) {\n    margin-top: ", ";\n  }\n\n  @media (max-width: ", "px) {\n    *::-webkit-scrollbar {\n      width: 6px; /* \u0448\u0438\u0440\u0438\u043D\u0430 scrollbar */\n      height: 61px;\n    }\n    *::-webkit-scrollbar-track {\n      background: transparent; /* \u0446\u0432\u0435\u0442 \u0434\u043E\u0440\u043E\u0436\u043A\u0438 */zz\n    }\n    *::-webkit-scrollbar-thumb {\n      border-radius: 3px; /* \u0437\u0430\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0448\u043A\u0438 */\n      background: #d9d9d9;\n      border: 1.55px solid rgba(0, 0, 0, 0); /* \u0438\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043C\u0430\u0440\u0434\u0436\u0438\u043D\u0430 */\n      background-clip: padding-box; /* \u0438\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043C\u0430\u0440\u0434\u0436\u0438\u043D\u0430 */\n    }\n  }\n"])), function (p) { return (p === null || p === void 0 ? void 0 : p.bgColor) ? p === null || p === void 0 ? void 0 : p.bgColor : 'linear-gradient(180deg, rgba(38, 44, 48, 0.52) 0%, rgba(38, 44, 48, 0.9) 100%)'; }, function (p) { return (p.fullscreen ? 'transparent' : null); }, function (p) { return (p.isPreviewer ? 'rgba(0, 0, 0, 0.5)' : null); }, function (p) { return (p.solidBackground ? null : 'blur(24px)'); }, LayoutConst.screen.m, function (_a) {
    var headerVisibleMobile = _a.headerVisibleMobile;
    return headerVisibleMobile ? '48px' : 0;
}, LayoutConst.screen.sm);
export var ModalClose = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  z-index: 300100;\n  position: absolute;\n  top: 80px;\n  right: ", ";\n  left: ", ";\n  transition: all 0.2s;\n\n  svg {\n    width: 72px;\n    height: 72px;\n  }\n  @media (max-width: ", "px), (max-height: ", "px) {\n    top: 32px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 56px;\n      height: 56px;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    top: 38px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 40px;\n      height: 40px;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    top: 12px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n\n      svg path {\n    fill: ", ";\n  }\n  &:hover {\n    svg path {\n      fill: ", ";\n    }\n  }\n"], ["\n  cursor: pointer;\n  z-index: 300100;\n  position: absolute;\n  top: 80px;\n  right: ", ";\n  left: ", ";\n  transition: all 0.2s;\n\n  svg {\n    width: 72px;\n    height: 72px;\n  }\n  @media (max-width: ", "px), (max-height: ", "px) {\n    top: 32px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 56px;\n      height: 56px;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    top: 38px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 40px;\n      height: 40px;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    top: 12px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n\n      svg path {\n    fill: ", ";\n  }\n  &:hover {\n    svg path {\n      fill: ", ";\n    }\n  }\n"
    // The modal provider
])), function (p) { return (p.closeLeft ? null : '80px'); }, function (p) { return (!p.closeLeft ? null : '80px'); }, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (p) { return (p.closeLeft ? null : '32px'); }, function (p) { return (!p.closeLeft ? null : '32px'); }, MEDIA_QUERY_MOBILE, function (p) { return (p.closeLeft ? null : '22px'); }, function (p) { return (!p.closeLeft ? null : '22px'); }, MEDIA_QUERY_NEW_MOBILE, function (p) { return (p.closeLeft ? null : '10px'); }, function (p) { return (!p.closeLeft ? null : '10px'); }, function (p) { return (p.isPreviewer ? '#FEFEFE' : '#909090'); }, function (p) { return (p.isPreviewer ? '#FEFEFE' : '#545453'); });
// The modal provider
export var ModalController = function () {
    var modal = useSelector(modalControllerSelector);
    var dispatch = useDispatch();
    var isVisible = useMemo(function () { return modal.name !== ''; }, [modal]);
    var isMobile = useIsMobile();
    var _a = useAdvancedLockBodyScroll(), lockBody = _a[0], unlockBody = _a[1];
    useEffect(function () {
        // if (isVisible) {
        //   window.document.body.scrollTop = 0;
        // }
        // window.document.body.style.overflow = isVisible ? "hidden" : "";
        // window.document.body.style.position = isVisible ? 'fixed' : '';
        isVisible ? lockBody() : unlockBody();
    }, [isVisible]);
    if (isVisible) {
        var ModalData = SHARED_MODALS[modal.name];
        var ModalComponent = ModalData.component, closable = ModalData.closable, solidBackground = ModalData.solidBackground, isPreviewer = ModalData.isPreviewer, bgColor = ModalData.bgColor, headerVisibleMobile = ModalData.headerVisibleMobile, hideCloseOnMobile = ModalData.hideCloseOnMobile;
        return (React.createElement(ModalControllerContainer, { isPreviewer: isPreviewer, bgColor: bgColor, solidBackground: solidBackground || (isMobile && modal.name !== 'tags'), headerVisibleMobile: headerVisibleMobile },
            (closable === undefined || closable) &&
                !(isMobile && hideCloseOnMobile) && (React.createElement(ModalClose, { bgColor: bgColor, closeLeft: false, isPreviewer: isPreviewer, onClick: function () { return dispatch(modalControllerActions.hideModal({})); } },
                React.createElement(CloseModalIcon, null))),
            React.createElement(ModalControllerContent, null,
                React.createElement(ModalComponent, __assign({}, modal.args)))));
    }
    return null;
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=modal.module.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
import React, { useCallback, useEffect, useMemo } from 'react';
import { LayoutConst } from './layout.module';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useAdvancedLockBodyScroll, useIsMobile } from '@brg/ui';
import { CloseModalIcon } from './CloseIconNew';
import CardSelectModal from '../../components/modals/CardSelectModal';
import SendProjectModal from "../../components/modals/SendProjectModal";
import { PreviewerModal } from "../../components/modals/previewerModal/previewerModal";
import ProductsSelectModal from '../../components/modals/ProductsSelectModal';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE, MEDIA_QUERY_NEW_MOBILE } from "../../constants/media";
import CardSelectManyModal from "../../components/modals/CardSelectModal/CardSelectManyModal";
import CodeEditorModal from '../../components/modals/CodeEditorModal.tsx';
import { RetractProjectModal } from '../../components/modals/RetractProjectModal';
import { TemplateModal } from '../../components/modals/TemplateModal/TemplateModal';
import { ReportForm } from '../../components/modals/ReportModal/ReportModal';
export var modalControllerSlice = createSlice({
    name: 'modalController',
    initialState: {
        name: '',
        args: {}
    },
    reducers: {
        showModal: function (state, action) {
            var _a;
            state.args = (_a = action.payload.args) !== null && _a !== void 0 ? _a : {};
            state.name = action.payload.name;
        },
        hideModal: function (state) {
            state.name = '';
            state.args = {};
        },
        updateArgs: function (state, action) {
            var _a;
            state.args = (_a = action.payload.args) !== null && _a !== void 0 ? _a : {};
        }
    }
});
export var modalControllerActions = modalControllerSlice.actions;
export var modalControllerReduces = modalControllerSlice.reducer;
export var SHARED_MODALS = {
    cardSelect: {
        component: CardSelectModal,
    },
    cardSelectMany: {
        component: CardSelectManyModal,
    },
    productsSelect: {
        component: ProductsSelectModal,
    },
    codeEditor: {
        component: CodeEditorModal,
    },
    projectSend: {
        component: SendProjectModal,
    },
    templateModal: {
        component: TemplateModal,
        closable: false,
    },
    report: {
        component: ReportForm,
        solidBackground: true,
        bgColor: '#fff'
    },
    retractProject: {
        closable: false,
        solidBackground: true,
        component: RetractProjectModal,
    },
    previewer: {
        component: PreviewerModal,
        isPreviewer: true,
        solidBackground: true
    }
};
// Селектор для контроллера модалок
export var modalControllerSelector = function (store) { return store.modalController; };
/**
 * Хук для модалок
 */
export var useModal = function () {
    var dispatch = useDispatch();
    var show = useCallback(function (name, props) {
        if (props === void 0) { props = {}; }
        dispatch(modalControllerActions.showModal({ name: name, args: props !== null && props !== void 0 ? props : {} }));
    }, [dispatch]);
    var hide = useCallback(function () {
        dispatch(modalControllerActions.hideModal({}));
    }, [dispatch]);
    var register = useCallback(function (name, modal) {
        SHARED_MODALS[name] = modal;
    }, []);
    var update = useCallback(function (props) {
        dispatch(modalControllerActions.updateArgs(props));
    }, [dispatch]);
    return { show: show, hide: hide, register: register, update: update /* isOpen */ };
};
export var withModal = function (Component) {
    return function WrappedComponent(props) {
        var modal = useModal();
        return React.createElement(Component, __assign({}, props, { modal: modal }));
    };
};
export var ModalControllerContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n  overflow-y: hidden;\n\n  @media (max-width: ", "px) {\n  }\n\n  @media (max-width: ", "px) {\n    overflow-y: overlay;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n  overflow-y: hidden;\n\n  @media (max-width: ", "px) {\n  }\n\n  @media (max-width: ", "px) {\n    overflow-y: overlay;\n  }\n"])), LayoutConst.screen.l, LayoutConst.screen.sm);
export var ModalControllerContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  max-width: 100vw;\n  max-height: 100vh;\n\n  z-index: 200000;\n  background: ", ";\n  background: ", ";\n  background: ", ";\n  backdrop-filter: ", ";\n  user-select: none;\n\n  @media (max-width: ", "px) {\n    margin-top: ", ";\n  }\n\n  @media (max-width: ", "px) {\n    *::-webkit-scrollbar {\n      width: 6px; /* \u0448\u0438\u0440\u0438\u043D\u0430 scrollbar */\n      height: 61px;\n    }\n    *::-webkit-scrollbar-track {\n      background: transparent; /* \u0446\u0432\u0435\u0442 \u0434\u043E\u0440\u043E\u0436\u043A\u0438 */zz\n    }\n    *::-webkit-scrollbar-thumb {\n      border-radius: 3px; /* \u0437\u0430\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0448\u043A\u0438 */\n      background: #d9d9d9;\n      border: 1.55px solid rgba(0, 0, 0, 0); /* \u0438\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043C\u0430\u0440\u0434\u0436\u0438\u043D\u0430 */\n      background-clip: padding-box; /* \u0438\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043C\u0430\u0440\u0434\u0436\u0438\u043D\u0430 */\n    }\n  }\n"], ["\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  max-width: 100vw;\n  max-height: 100vh;\n\n  z-index: 200000;\n  background: ", ";\n  background: ", ";\n  background: ", ";\n  backdrop-filter: ", ";\n  user-select: none;\n\n  @media (max-width: ", "px) {\n    margin-top: ", ";\n  }\n\n  @media (max-width: ", "px) {\n    *::-webkit-scrollbar {\n      width: 6px; /* \u0448\u0438\u0440\u0438\u043D\u0430 scrollbar */\n      height: 61px;\n    }\n    *::-webkit-scrollbar-track {\n      background: transparent; /* \u0446\u0432\u0435\u0442 \u0434\u043E\u0440\u043E\u0436\u043A\u0438 */zz\n    }\n    *::-webkit-scrollbar-thumb {\n      border-radius: 3px; /* \u0437\u0430\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0448\u043A\u0438 */\n      background: #d9d9d9;\n      border: 1.55px solid rgba(0, 0, 0, 0); /* \u0438\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043C\u0430\u0440\u0434\u0436\u0438\u043D\u0430 */\n      background-clip: padding-box; /* \u0438\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043C\u0430\u0440\u0434\u0436\u0438\u043D\u0430 */\n    }\n  }\n"])), function (p) { return (p === null || p === void 0 ? void 0 : p.bgColor) ? p === null || p === void 0 ? void 0 : p.bgColor : 'linear-gradient(180deg, rgba(38, 44, 48, 0.52) 0%, rgba(38, 44, 48, 0.9) 100%)'; }, function (p) { return (p.fullscreen ? 'transparent' : null); }, function (p) { return (p.isPreviewer ? 'rgba(0, 0, 0, 0.5)' : null); }, function (p) { return (p.solidBackground ? null : 'blur(24px)'); }, LayoutConst.screen.m, function (_a) {
    var headerVisibleMobile = _a.headerVisibleMobile;
    return headerVisibleMobile ? '48px' : 0;
}, LayoutConst.screen.sm);
export var ModalClose = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  z-index: 300100;\n  position: absolute;\n  top: 80px;\n  right: ", ";\n  left: ", ";\n  transition: all 0.2s;\n\n  svg {\n    width: 72px;\n    height: 72px;\n  }\n  @media (max-width: ", "px), (max-height: ", "px) {\n    top: 32px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 56px;\n      height: 56px;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    top: 38px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 40px;\n      height: 40px;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    top: 12px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n\n      svg path {\n    fill: ", ";\n  }\n  &:hover {\n    svg path {\n      fill: ", ";\n    }\n  }\n"], ["\n  cursor: pointer;\n  z-index: 300100;\n  position: absolute;\n  top: 80px;\n  right: ", ";\n  left: ", ";\n  transition: all 0.2s;\n\n  svg {\n    width: 72px;\n    height: 72px;\n  }\n  @media (max-width: ", "px), (max-height: ", "px) {\n    top: 32px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 56px;\n      height: 56px;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    top: 38px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 40px;\n      height: 40px;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    top: 12px;\n    right: ", ";\n    left: ", ";\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n\n      svg path {\n    fill: ", ";\n  }\n  &:hover {\n    svg path {\n      fill: ", ";\n    }\n  }\n"
    // The modal provider
])), function (p) { return (p.closeLeft ? null : '80px'); }, function (p) { return (!p.closeLeft ? null : '80px'); }, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (p) { return (p.closeLeft ? null : '32px'); }, function (p) { return (!p.closeLeft ? null : '32px'); }, MEDIA_QUERY_MOBILE, function (p) { return (p.closeLeft ? null : '22px'); }, function (p) { return (!p.closeLeft ? null : '22px'); }, MEDIA_QUERY_NEW_MOBILE, function (p) { return (p.closeLeft ? null : '10px'); }, function (p) { return (!p.closeLeft ? null : '10px'); }, function (p) { return (p.isPreviewer ? '#FEFEFE' : '#909090'); }, function (p) { return (p.isPreviewer ? '#FEFEFE' : '#545453'); });
// The modal provider
export var ModalController = function () {
    var modal = useSelector(modalControllerSelector);
    var dispatch = useDispatch();
    var isVisible = useMemo(function () { return modal.name !== ''; }, [modal]);
    var isMobile = useIsMobile();
    var _a = useAdvancedLockBodyScroll(), lockBody = _a[0], unlockBody = _a[1];
    useEffect(function () {
        // if (isVisible) {
        //   window.document.body.scrollTop = 0;
        // }
        // window.document.body.style.overflow = isVisible ? "hidden" : "";
        // window.document.body.style.position = isVisible ? 'fixed' : '';
        isVisible ? lockBody() : unlockBody();
    }, [isVisible]);
    if (isVisible) {
        var ModalData = SHARED_MODALS[modal.name];
        var ModalComponent = ModalData.component, closable = ModalData.closable, solidBackground = ModalData.solidBackground, isPreviewer = ModalData.isPreviewer, bgColor = ModalData.bgColor, headerVisibleMobile = ModalData.headerVisibleMobile, hideCloseOnMobile = ModalData.hideCloseOnMobile;
        return (React.createElement(ModalControllerContainer, { isPreviewer: isPreviewer, bgColor: bgColor, solidBackground: solidBackground || (isMobile && modal.name !== 'tags'), headerVisibleMobile: headerVisibleMobile },
            (closable === undefined || closable) &&
                !(isMobile && hideCloseOnMobile) && (React.createElement(ModalClose, { bgColor: bgColor, closeLeft: false, isPreviewer: isPreviewer, onClick: function () { return dispatch(modalControllerActions.hideModal({})); } },
                React.createElement(CloseModalIcon, null))),
            React.createElement(ModalControllerContent, null,
                React.createElement(ModalComponent, __assign({}, modal.args)))));
    }
    return null;
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=modal.module.js.map